module.exports = __webpack_public_path__ + "img/select.07772724.svg";